import React from 'react';

function FloatingWhatsApp({ phone, message = 'Hi, i want to know more.' }) {
  const encodedMessage = encodeURIComponent(message);
  const href = `https://wa.me${phone ? `/${phone}` : ''}?text=${encodedMessage}`;

  const containerStyle = {
    position: 'fixed',
    right: '20px',
    bottom: '20px',
    zIndex: 1000,
  };

  const buttonStyle = {
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    backgroundColor: '#25D366',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 6px 16px rgba(0,0,0,0.25)',
    textDecoration: 'none',
    transition: 'transform 0.15s ease, box-shadow 0.15s ease',
  };

  const iconStyle = {
    width: '28px',
    height: '28px',
    display: 'block',
  };

  const handleMouseEnter = (e) => {
    e.currentTarget.style.transform = 'translateY(-2px)';
    e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.28)';
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.25)';
  };

  return (
    <div style={containerStyle}>
      <a
        href={href}
        target="_blank"
        rel="noreferrer noopener"
        aria-label="Chat on WhatsApp"
        style={buttonStyle}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {/* WhatsApp SVG icon */}
        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" style={iconStyle} aria-hidden="true">
          <path fill="#25D366" d="M0 0h32v32H0z" opacity="0"/>
          <path fill="#fff" d="M16.003 5.333c-5.89 0-10.667 4.776-10.667 10.666 0 1.88.49 3.7 1.42 5.318L5.333 26.667l5.5-1.408a10.58 10.58 0 0 0 5.17 1.307c5.89 0 10.667-4.776 10.667-10.667S21.893 5.333 16.003 5.333zm0 19.2a8.5 8.5 0 0 1-4.333-1.183l-.31-.184-3.267.836.872-3.183-.203-.326A8.48 8.48 0 0 1 7.5 16c0-4.69 3.813-8.5 8.503-8.5 4.69 0 8.5 3.81 8.5 8.5 0 4.69-3.81 8.5-8.5 8.5z"/>
          <path fill="#fff" d="M12.956 11.79c-.198-.44-.407-.448-.596-.457-.154-.007-.332-.006-.51-.006a.98.98 0 0 0-.708.332c-.244.26-.93.908-.93 2.215 0 1.307.953 2.57 1.085 2.747.133.176 1.84 2.944 4.57 4.007.638.252 1.135.403 1.522.516.64.186 1.225.16 1.686.097.514-.071 1.585-.648 1.81-1.276.225-.628.225-1.165.158-1.276-.066-.112-.247-.178-.516-.312-.268-.133-1.585-.78-1.83-.868-.245-.088-.423-.133-.602.134-.18.267-.69.868-.846 1.046-.155.178-.311.2-.58.067-.268-.134-1.135-.419-2.162-1.336-.799-.711-1.34-1.588-1.496-1.856-.156-.267-.017-.412.117-.545.12-.12.268-.312.4-.467.133-.155.177-.267.266-.445.089-.178.044-.334-.022-.468-.066-.133-.58-1.432-.816-1.953z"/>
        </svg>
      </a>
    </div>
  );
}

export default FloatingWhatsApp;


